import { useEffect } from 'react'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import logoUrl from '@/assets/元点引擎.svg'
import { logger } from '@/lib/logger'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { useUser } from '@/features/auth/hooks/use-user'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { LoginForm } from './components/login/login-container'
import { ProfileDropdown } from './components/profile-dropdown'
import { RegisterForm } from './components/register/register-container'

export function AuthButton() {
  const { accessToken, setUser } = useAuthStore((state) => state.auth)
  const { open, setOpen } = useAuthStore((state) => state.authDialog)
  const { view } = useAuthStore((state) => state.authView)
  const { userProfile } = useUser()

  useEffect(() => {
    if (accessToken && userProfile) {
      setUser(userProfile)
    }
    logger.debug(userProfile)
  }, [accessToken, userProfile])

  if (accessToken) {
    return <ProfileDropdown />
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant='outline'>登录/注册</Button>
      </DialogTrigger>
      <VisuallyHidden>
        <DialogTitle>登录/注册</DialogTitle>
        <DialogDescription>请输入您的凭据进行登录或注册</DialogDescription>
      </VisuallyHidden>
      <DialogContent className='bg-card aria-label="登录和注册认证窗口" flex flex-col gap-6 border-none p-6 shadow-none sm:p-8'>
        <div className='flex flex-col items-center justify-center pt-4'>
          <div
            style={{
              maskImage: `url('${logoUrl}')`,
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'contain',
              backgroundColor: 'var(--foreground)',
            }}
            className='h-20 w-full max-w-[320px]'
            role='img'
            aria-label='元点引擎 Logo'
          />
        </div>

        {view === 'login' ? <LoginForm /> : <RegisterForm />}
      </DialogContent>
    </Dialog>
  )
}
